// Tattoo Health Information - Comprehensive Guide
// Enfeksiyon, Skar Doku, Alerji ve Diğer Komplikasyonlar

export const healthConditions = {
  infection: {
    tr: {
      name: "Enfeksiyon",
      description: "Dövme enfeksiyonu, bakterilerin açık yaraya girmesiyle oluşur.",
      symptoms: [
        "Aşırı kızarıklık ve şişlik",
        "Sarı/yeşil irin akıntısı",
        "Ateş (38°C üzeri)",
        "Dövme bölgesinde sıcaklık artışı",
        "Kötü koku",
        "Şiddetli ağrı (artarak devam eden)"
      ],
      causes: [
        "Hijyen eksikliği",
        "Kirli ekipman kullanımı",
        "Bakım talimatlarına uymama",
        "Kirli suyla temas",
        "Kabukları koparmak"
      ],
      treatment: [
        "Hemen bir doktora başvurun",
        "Antibiyotik tedavisi gerekebilir",
        "Bölgeyi temiz ve kuru tutun",
        "Asla sıkmayın veya patlatmaya çalışmayın"
      ],
      severity: "critical",
      seekMedical: true
    },
    en: {
      name: "Infection",
      description: "Tattoo infection occurs when bacteria enter the open wound.",
      symptoms: [
        "Excessive redness and swelling",
        "Yellow/green pus discharge",
        "Fever (above 38°C/100.4°F)",
        "Increased warmth around tattoo",
        "Bad odor",
        "Severe pain (progressively worsening)"
      ],
      causes: [
        "Poor hygiene",
        "Contaminated equipment",
        "Not following aftercare instructions",
        "Contact with dirty water",
        "Picking at scabs"
      ],
      treatment: [
        "See a doctor immediately",
        "Antibiotic treatment may be required",
        "Keep the area clean and dry",
        "Never squeeze or try to pop"
      ],
      severity: "critical",
      seekMedical: true
    }
  },
  scarring: {
    tr: {
      name: "Skar Doku (Yara İzi)",
      description: "Dövme iyileşme sürecinde oluşabilen kalıcı doku hasarı.",
      types: [
        {
          name: "Hipertrofik Skar",
          description: "Dövme sınırları içinde kalan kabarık yara izi",
          treatment: "Silikon jel, kortikosteroid enjeksiyonu"
        },
        {
          name: "Keloid",
          description: "Dövme sınırlarını aşan, büyüyen skar dokusu",
          treatment: "Dermatoloji konsültasyonu gerektirir"
        },
        {
          name: "Atrofik Skar",
          description: "Çukur şeklinde iz bırakan skar",
          treatment: "Lazer tedavisi, dolgu uygulamaları"
        }
      ],
      prevention: [
        "Kabukları asla koparmayın",
        "Aşırı güneşten koruyun",
        "Düzenli nemlendirin",
        "Deneyimli sanatçı seçin",
        "Kaliteli mürekkep kullanımı"
      ],
      riskFactors: [
        "Genetik yatkınlık",
        "Koyu ten rengi",
        "Geçmiş keloid öyküsü",
        "Derin iğne penetrasyonu"
      ],
      severity: "moderate",
      seekMedical: false
    },
    en: {
      name: "Scarring",
      description: "Permanent tissue damage that can occur during tattoo healing.",
      types: [
        {
          name: "Hypertrophic Scar",
          description: "Raised scar within tattoo boundaries",
          treatment: "Silicone gel, corticosteroid injections"
        },
        {
          name: "Keloid",
          description: "Scar tissue that grows beyond tattoo boundaries",
          treatment: "Requires dermatology consultation"
        },
        {
          name: "Atrophic Scar",
          description: "Depressed/sunken scarring",
          treatment: "Laser treatment, filler applications"
        }
      ],
      prevention: [
        "Never pick at scabs",
        "Protect from excessive sun",
        "Moisturize regularly",
        "Choose experienced artist",
        "Quality ink usage"
      ],
      riskFactors: [
        "Genetic predisposition",
        "Darker skin tones",
        "History of keloids",
        "Deep needle penetration"
      ],
      severity: "moderate",
      seekMedical: false
    }
  },
  allergicReaction: {
    tr: {
      name: "Alerjik Reaksiyon",
      description: "Dövme mürekkebine veya bakım ürünlerine karşı bağışıklık tepkisi.",
      symptoms: [
        "Şiddetli kaşıntı",
        "Döküntü ve kızarıklık",
        "Şişlik (sadece renkli bölgelerde)",
        "Kabarcıklar",
        "Pullanma",
        "Dövme bölgesinde kuruluk"
      ],
      commonAllergens: [
        "Kırmızı mürekkep (en yaygın)",
        "Sarı mürekkep",
        "Kobalt mavisi",
        "Nikel içeren mürekkepler",
        "Lateks eldiven",
        "Bakım kremleri"
      ],
      treatment: [
        "Antihistaminik ilaçlar",
        "Topikal kortikosteroid",
        "Soğuk kompres",
        "Şiddetli vakalarda doktora başvurun"
      ],
      note: "Alerjik reaksiyonlar yıllar sonra bile ortaya çıkabilir.",
      severity: "moderate",
      seekMedical: true
    },
    en: {
      name: "Allergic Reaction",
      description: "Immune response to tattoo ink or aftercare products.",
      symptoms: [
        "Severe itching",
        "Rash and redness",
        "Swelling (only in colored areas)",
        "Blisters",
        "Flaking",
        "Dryness around tattoo"
      ],
      commonAllergens: [
        "Red ink (most common)",
        "Yellow ink",
        "Cobalt blue",
        "Nickel-containing inks",
        "Latex gloves",
        "Aftercare creams"
      ],
      treatment: [
        "Antihistamine medication",
        "Topical corticosteroids",
        "Cold compress",
        "See a doctor for severe cases"
      ],
      note: "Allergic reactions can appear years after getting the tattoo.",
      severity: "moderate",
      seekMedical: true
    }
  },
  blowout: {
    tr: {
      name: "Mürekkep Dağılması (Blowout)",
      description: "Mürekkebin deri altında yayılarak bulanık görünüm oluşturması.",
      symptoms: [
        "Çizgilerin bulanık/gölgeli görünmesi",
        "Mavi-gri lekeler",
        "Dövme sınırlarının belirsizleşmesi"
      ],
      causes: [
        "İğnenin çok derinden girmesi",
        "Deneyimsiz sanatçı",
        "İnce derili bölgeler (bilek, ayak)",
        "Dövme sırasında hareket"
      ],
      treatment: [
        "Lazer tedavisi",
        "Cover-up dövme",
        "Tam düzeltme mümkün olmayabilir"
      ],
      prevention: [
        "Deneyimli sanatçı seçin",
        "İnce derili bölgelerde dikkatli olun"
      ],
      severity: "low",
      seekMedical: false
    },
    en: {
      name: "Ink Blowout",
      description: "Ink spreading under the skin causing a blurry appearance.",
      symptoms: [
        "Blurry/shadowy lines",
        "Blue-gray spots",
        "Unclear tattoo boundaries"
      ],
      causes: [
        "Needle inserted too deep",
        "Inexperienced artist",
        "Thin-skinned areas (wrist, foot)",
        "Movement during tattooing"
      ],
      treatment: [
        "Laser treatment",
        "Cover-up tattoo",
        "Complete correction may not be possible"
      ],
      prevention: [
        "Choose experienced artist",
        "Be cautious with thin-skinned areas"
      ],
      severity: "low",
      seekMedical: false
    }
  },
  granuloma: {
    tr: {
      name: "Granülom",
      description: "Mürekkeğe karşı oluşan küçük nodüller/yumrular.",
      symptoms: [
        "Dövme üzerinde küçük yumrular",
        "Sert nodüller",
        "Genellikle ağrısız"
      ],
      causes: [
        "Vücudun mürekkeği yabancı madde olarak algılaması",
        "Belirli mürekkep pigmentleri"
      ],
      treatment: [
        "Kortikosteroid enjeksiyonu",
        "Cerrahi müdahale (nadir)",
        "Bekle-gör yaklaşımı"
      ],
      severity: "low",
      seekMedical: true
    },
    en: {
      name: "Granuloma",
      description: "Small nodules/bumps that form in response to ink.",
      symptoms: [
        "Small bumps on tattoo",
        "Hard nodules",
        "Usually painless"
      ],
      causes: [
        "Body recognizing ink as foreign material",
        "Certain ink pigments"
      ],
      treatment: [
        "Corticosteroid injections",
        "Surgical removal (rare)",
        "Wait-and-see approach"
      ],
      severity: "low",
      seekMedical: true
    }
  },
  mriReaction: {
    tr: {
      name: "MRI Reaksiyonu",
      description: "MRI taraması sırasında dövme bölgesinde olası reaksiyon.",
      symptoms: [
        "Yanma hissi",
        "Şişlik",
        "Geçici kaşıntı"
      ],
      cause: "Bazı mürekkeplerdeki metal partiküller manyetik alana tepki verebilir.",
      prevention: [
        "MRI öncesi radyoloji uzmanını bilgilendirin",
        "Kaliteli mürekkep kullanılan stüdyo seçin"
      ],
      note: "Modern mürekkeplerle nadir görülür.",
      severity: "low",
      seekMedical: false
    },
    en: {
      name: "MRI Reaction",
      description: "Possible reaction in tattoo area during MRI scan.",
      symptoms: [
        "Burning sensation",
        "Swelling",
        "Temporary itching"
      ],
      cause: "Metal particles in some inks may react to magnetic field.",
      prevention: [
        "Inform radiologist before MRI",
        "Choose studio using quality inks"
      ],
      note: "Rare with modern inks.",
      severity: "low",
      seekMedical: false
    }
  }
};

export const healingStages = {
  tr: [
    {
      day: "1-3",
      name: "Açık Yara Dönemi",
      description: "Dövme taze ve hassas. Kızarıklık, şişlik ve sızıntı normal.",
      care: ["Bandajı 2-4 saat sonra çıkarın", "Nazikçe yıkayın", "İnce katman krem"]
    },
    {
      day: "4-7",
      name: "Pullanma Başlangıcı",
      description: "Kaşıntı başlar, ince kabuklar oluşur.",
      care: ["Kabukları koparmayın", "Düzenli nemlendirin", "Bol giysiler giyin"]
    },
    {
      day: "8-14",
      name: "Yoğun Pullanma",
      description: "Kabuklar dökülür, dövme mat görünür.",
      care: ["Sabırlı olun", "Nemlendirmeye devam", "Direkt güneşten kaçının"]
    },
    {
      day: "15-30",
      name: "İyileşme Sonu",
      description: "Yüzey iyileşir, dövme parlamaya başlar.",
      care: ["SPF 30+ güneş kremi", "Normal bakıma geçiş"]
    },
    {
      day: "30+",
      name: "Tam İyileşme",
      description: "Derin doku iyileşmesi tamamlanır.",
      care: ["Düzenli nemlendirme", "Güneş koruması ömür boyu"]
    }
  ],
  en: [
    {
      day: "1-3",
      name: "Open Wound Phase",
      description: "Tattoo is fresh and sensitive. Redness, swelling, and oozing are normal.",
      care: ["Remove bandage after 2-4 hours", "Gently wash", "Apply thin layer of cream"]
    },
    {
      day: "4-7",
      name: "Peeling Begins",
      description: "Itching starts, thin scabs form.",
      care: ["Don't pick scabs", "Moisturize regularly", "Wear loose clothing"]
    },
    {
      day: "8-14",
      name: "Heavy Peeling",
      description: "Scabs fall off, tattoo looks dull.",
      care: ["Be patient", "Continue moisturizing", "Avoid direct sunlight"]
    },
    {
      day: "15-30",
      name: "Final Healing",
      description: "Surface heals, tattoo starts to shine.",
      care: ["SPF 30+ sunscreen", "Transition to normal care"]
    },
    {
      day: "30+",
      name: "Complete Healing",
      description: "Deep tissue healing completes.",
      care: ["Regular moisturizing", "Sun protection for life"]
    }
  ]
};

export const emergencySymptoms = {
  tr: {
    title: "ACİL DURUMLAR - Hemen Doktora Gidin!",
    symptoms: [
      "38°C üzeri ateş",
      "Kırmızı çizgiler (lenf yolları boyunca)",
      "Şiddetli ağrı (artarak)",
      "Bol miktarda irin",
      "Hızla yayılan kızarıklık",
      "Nefes darlığı (alerjik reaksiyon)",
      "Yüz/boğaz şişmesi"
    ],
    action: "112'yi arayın veya en yakın acil servise gidin!"
  },
  en: {
    title: "EMERGENCIES - See a Doctor Immediately!",
    symptoms: [
      "Fever above 38°C/100.4°F",
      "Red streaks (along lymph nodes)",
      "Severe pain (increasing)",
      "Heavy pus discharge",
      "Rapidly spreading redness",
      "Difficulty breathing (allergic reaction)",
      "Face/throat swelling"
    ],
    action: "Call emergency services or go to nearest ER!"
  }
};

export default { healthConditions, healingStages, emergencySymptoms };
